<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title> </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div *ngIf="readerConnected&&!refundError">
    <h2 class="ion-text-center ion-padding payment-title">
      Pass the card reader to the customer to complete the refund
    </h2>
    <ion-row size="12" class="height-200">
      <salonmonster-load-mask
        [ngClass]="'center-block'"
        *ngIf="refundProcessing"
      ></salonmonster-load-mask>
    </ion-row>
  </div>
  <div class="reader-box" *ngIf="foundReaders && !readerConnected">
    <ion-item class="reader-disconnected-top ion-no-padding" lines="none">
      <span>Card reader not connected</span>
      <ion-button
        *ngIf="!connectPushed"
        (click)="connectCardReader()"
        slot="end"
        class="reader-reconnect-button ion-no-margin"
        >Reconnect</ion-button
      >
      <salonmonster-small-checkmark-loader
        class="reader-disconnected-loader"
        *ngIf="connectPushed"
        slot="end"
        [completed]="readerConnectSuccessful"
      ></salonmonster-small-checkmark-loader>
    </ion-item>
    <div *ngIf="cardReaderConnectError" class="reader-disconnected-bottom">
      <p class="sm-error">Oops! something went wrong</p>
      Please check your internet connection and make sure that the reader is
      powered on and connected to the internet.
    </div>
  </div>

  <div *ngIf="refundError" class="ion-text-center">
    <h2 class="ion-padding payment-title">Refund Failed</h2>
    <h4> Card was declined</h4>
    <ion-button (click)="retry()">
      Try again
    </ion-button>
  </div>
</ion-content>
